import {
  ApplicationConfig,
  ErrorHandler,
  importProvidersFrom,
  provideZoneChangeDetection,
} from '@angular/core';
import { OVERLAY_DEFAULT_CONFIG } from '@angular/cdk/overlay';
import {
  provideHttpClient,
  withInterceptorsFromDi,
  withXhr,
} from '@angular/common/http';
import { BrowserModule } from '@angular/platform-browser';
import {
  PreloadAllModules,
  provideRouter,
  withComponentInputBinding,
  withPreloading,
  withRouterConfig,
} from '@angular/router';
import { createErrorHandler } from '@sentry/angular';
import { appRoutes } from './app.routes';
import { NgSelectModule } from '@ng-select/ng-select';
import { NgxDatatableModule } from '@swimlane/ngx-datatable';
import { FormsModule } from '@angular/forms';
import { AngularSvgIconModule } from 'angular-svg-icon';
import { provideOptimus } from '@openng/optimus-ui/config';
import { MessageService } from '@openng/optimus-ui/api';
import { AccountModule } from './account/account.module';
import { HttpInterceptors } from './core/interceptors';
import { HttpLink } from './graphql/http-link';
import { provideGraphQL } from './graphql/provide-graphql';
import CustomOptimusTheme from 'src/assets/theme/custom';

export const appConfig: ApplicationConfig = {
  providers: [
    importProvidersFrom(
      BrowserModule,
      NgSelectModule,
      NgxDatatableModule,
      FormsModule,
      AccountModule,
      AngularSvgIconModule.forRoot(),
    ),
    provideZoneChangeDetection({ eventCoalescing: true }),
    HttpLink,
    provideGraphQL(),
    HttpInterceptors,
    MessageService,
    { provide: OVERLAY_DEFAULT_CONFIG, useValue: { usePopover: false } },
    {
      provide: ErrorHandler,
      useValue: createErrorHandler({ showDialog: false }),
    },
    provideHttpClient(withXhr(), withInterceptorsFromDi()),
    provideOptimus({
      theme: {
        preset: CustomOptimusTheme,
        options: {
          // Dark mode is disabled until a dark theme is designed.
          // To enable, add 'dark-mode-enabled' class to the html element.
          darkModeSelector: '.dark-mode-enabled',
          // Optimus injects this order at the top of the head, before styles.css,
          // so it sets the layer priority. Keep it in sync with layer-order.css.
          cssLayer: {
            name: 'optimus-ui',
            order:
              'properties, theme, base, ngselect, cdk, vendor, optimus-ui, components, overrides, utilities',
          },
        },
      },
    }),
    provideRouter(
      appRoutes,
      withPreloading(PreloadAllModules),
      withComponentInputBinding(),
      withRouterConfig({
        onSameUrlNavigation: 'reload',
      }),
    ),
  ],
};
